module.exports = __webpack_public_path__ + "img/p23.c277ff88.png";